import React from 'react';
import SEO from '../../components/SEO/SEO';
import SubServiceTemplate from '../../components/SubServiceTemplate/SubServiceTemplate';

const LinkedInAds = () => {
  const pageData = {
    category: "LINKEDIN ADS",
    title: "LinkedIn Ads Management",
    description: "Connect with decision-makers and B2B professionals where business happens. Our LinkedIn advertising specialists create targeted campaigns that generate high-quality leads, nurture relationships, and drive enterprise sales.",

    features: [
      {
        title: "B2B Precision Targeting",
        description: "Target by job title, company size, industry, seniority, skills, and more to reach exactly the right decision-makers."
      },
      {
        title: "Lead Gen Forms",
        description: "Native LinkedIn lead forms with pre-filled data that make it frictionless for prospects to convert instantly."
      },
      {
        title: "Sponsored Content & InMail",
        description: "Promote thought leadership content and send personalized messages directly to prospects' LinkedIn inboxes."
      },
      {
        title: "ABM Campaign Strategies",
        description: "Account-based marketing campaigns targeting specific companies and decision-makers for high-value B2B sales."
      },
      {
        title: "Video & Document Ads",
        description: "Showcase expertise with native video ads and downloadable documents that establish authority and trust."
      },
      {
        title: "Conversion Tracking & Analytics",
        description: "Monitor lead quality, cost per lead, engagement rates, and full-funnel attribution for B2B sales cycles."
      }
    ],

    benefits: [
      {
        title: "Access Decision-Makers",
        description: "Reach 900M+ professionals including C-suite executives and key decision-makers in your target accounts."
      },
      {
        title: "Higher Lead Quality",
        description: "Professional context and precise targeting deliver leads that are more qualified and sales-ready."
      },
      {
        title: "Thought Leadership",
        description: "Build brand authority and credibility within your industry through strategic content promotion."
      },
      {
        title: "Long Sales Cycles",
        description: "Perfect for B2B businesses with complex sales processes and multiple stakeholder involvement."
      }
    ],

    process: [
      {
        title: "ICP & Audience Definition",
        description: "Define your ideal customer profile and build highly targeted audience segments based on professional criteria."
      },
      {
        title: "Content & Creative Development",
        description: "Create professional, value-driven ad creatives and compelling offers that resonate with B2B audiences."
      },
      {
        title: "Campaign Launch & Lead Capture",
        description: "Deploy campaigns with optimized lead gen forms, tracking, and CRM integration for seamless lead management."
      },
      {
        title: "Nurture & Optimize",
        description: "Analyze lead quality, refine targeting, and optimize campaigns while coordinating with sales for feedback loops."
      }
    ],

    relatedServices: [
      {
        title: "Google Ads",
        description: "Capture search demand with Google search campaigns",
        link: "/services/paid-ads/google-ads"
      },
      {
        title: "Meta Ads",
        description: "Expand reach with Facebook and Instagram advertising",
        link: "/services/paid-ads/meta-ads"
      },
      {
        title: "Content Marketing",
        description: "Build thought leadership with strategic content",
        link: "/services/seo/content-writing"
      }
    ],

    ctaText: "Ready to generate high-quality B2B leads? Let's craft a LinkedIn strategy that fills your pipeline.",
    ctaLink: "/contact",
    parentLink: "/services/paid-ads",
    parentTitle: "Paid Ads"
  };

  return (
    <>
      <SubServiceTemplate {...pageData} />
      
            <SEO 
                title="Linked In Ads Services" 
                description="Learn more about our Linked In Ads services to grow your business online with Digi Network." 
                canonical="/paid-ads/linked-in-ads" 
            />

    </>
  );
};

export default LinkedInAds;
